<template>
  <div class="card-check-fonction">
    <label :for="fonctionId">
      <div
        :class="[
          'card-fonction',
          activeFonctionList.includes(fonctionId) ? 'is-active' : ''
        ]"
      >
        <div class="card-content">
          <img :src="require('@/assets/' + fonctionImg)" /><br />
          {{ fonctionTitre }}
          <span
            v-if="
              fonctionId === 'E' ||
                fonctionId === 'D' ||
                fonctionId === 'A' ||
                fonctionId === 'O'
            "
            class="je-souhaite-fonction-text-info"
            style="color: #dc3545;"
            >(1)</span
          >
          <span
            v-if="fonctionId === 'E'"
            class="je-souhaite-fonction-text-info"
            style="color: #dc3545;"
          >
            (2)</span
          >
        </div>
      </div>
    </label>
    <input
      type="checkbox"
      :disabled="isFonctionDisabled"
      :checked="isFonctionChecked"
      :id="fonctionId"
      v-bind:value="fonctionId"
      name="fonction"
      @change="updateActiveFonctionList"
    />
  </div>
</template>

<script>
export default {
  props: [
    "fonctionId",
    "fonctionTitre",
    "fonctionImg",
    "isFonctionDisabled",
    "isFonctionChecked",
    "activeFonctionList"
  ],

  methods: {
    updateActiveFonctionList() {
      this.$emit("onUpdateFonctionList", "", this.fonctionId);
    }
  }
};
</script>

<style scoped>
.is-active {
  border: 1px solid #003690 !important;
}

.card-content {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}

.je-souhaite-fonction-text-info {
  text-align: left;
  font-family: Lato;
  font-size: 9px;
  line-height: 17px;
  color: #000000;
  white-space: pre-line;
}
</style>
